<template>
  <div class="resetpsw-container">
    <BaseHead />
    <section class="my-body">
      <div class="gb-wrap">
        <div class="my-steps clearfix">
          <div class="my-step" :class="{'my-active': curStep >= 1}">
            <div class="my-step-group">
              <em class="my-step-num">1</em>
              <p class="my-step-name">输入账号</p>
            </div>
          </div>
          <div class="my-step" :class="{'my-active': curStep >= 2}">
            <div class="my-step-group">
              <em class="my-step-num">2</em>
              <p class="my-step-name">重置密码</p>
            </div>
          </div>
          <div class="my-step" :class="{'my-active': curStep >= 3}">
            <div class="my-step-group">
              <em class="my-step-num">3</em>
              <p class="my-step-name">修改成功</p>
            </div>
          </div>
        </div>
        <div class="my-content">
          <!-- 第1步 -->
          <div class="my-form my-form_1" v-if="curStep == 1">
            <div class="my-inputgroup clearfix my-inputgroup-witharea">
              <select v-model="activeAreaCode" @change="resetError(formPhone)">
                <option v-for="item in areaCodeList" :value="item.value" :key="item.value">{{item.title}} {{item.label}}</option>
              </select>
              <div class="my-inputwrap">
                <i class="my-inputicon my-inputicon_phone"></i>
                <input
                  type="tel"
                  v-model="formPhone.value"
                  placeholder="请输入手机号"
                  @input="resetError(formPhone)"
                />
                <p v-if="formPhone.error" class="my-inputtip">手机号码格式有误</p>
              </div>
            </div>
            <div class="my-inputgroup clearfix my-inputgroup-withcode">
              <div class="my-inputwrap">
                <i class="my-inputicon my-inputicon_code"></i>
                <input
                  type="text"
                  v-model="formCode.value"
                  placeholder="请输入验证码"
                  @input="resetError(formCode)"
                />
              </div>
              <div
                class="my-inputbtn"
                :class="{'js-is-wait': isWaitCode}"
                @click="toggleImgVerif(true)"
              >{{waitText}}</div>
              <p v-if="formCode.error" class="my-inputtip">验证码有误</p>
            </div>
            <div class="my-loginbtn ut-cp" @click="doConfirm()">下一步</div>
          </div>
          <!-- 第2步 -->
          <div class="my-form my-form_2" v-if="curStep == 2">
            <div class="my-inputwrap">
              <i class="my-inputicon my-inputicon_psw"></i>
              <input
                type="password"
                v-model="formPsw.value"
                placeholder="请输入密码"
                @input="resetError(formPsw)"
              />
              <p v-if="formPsw.error" class="my-inputtip">密码有误</p>
            </div>
            <div class="my-loginbtn ut-cp" @click="doConfirm()">下一步</div>
          </div>
          <!-- 第3步 -->
          <div class="my-form my-form_3" v-if="curStep == 3">
            <i class="fa fa-check-circle" aria-hidden="true"></i>
            <p>恭喜你，密码设置成功！</p>
            <div class="my-loginbtn ut-cp" @click="doConfirm()">去登录</div>
          </div>
        </div>
      </div>
    </section>
    <BaseImgVerif v-if="isShowImgVerif" @success="sendCode" @close="toggleImgVerif(false)" />
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import BaseHead from '@/components/BaseHead'
import BaseImgVerif from '@/components/BaseImgVerif'
import { areaCodeList } from '@/constants'

export default {
  name: "ResetPsw",
  components: {
    BaseHead,
    BaseImgVerif
  },
  data() {
    return {
      curStep: 1,
      isWaitCode: false,
      isFirstSend: true, // 是否第一次发送验证码
      isShowImgVerif: false,
      waitCount: 60,
      waitTimer: null,
      formPhone: {
        value: '',
        error: false
      },
      formPsw: {
        value: '',
        error: false
      },
      formCode: {
        value: '',
        error: false
      },
      activeAreaCode: '86',
      areaCodeList,
    }
  },
  computed: {
    ...mapGetters([
      'vx_get_token'
    ]),
    waitText() {
      return this.isWaitCode ? `(${this.waitCount}s)后重发` : (this.isFirstSend ? '获取验证码' : '重新发送')
    }
  },
  watch: {
    isWaitCode(v) {
      clearInterval(this.waitTimer)
      if (v) {
        this.isFirstSend = false
        this.waitCount = 60
        this.waitTimer = setInterval(() => {
          this.waitCount--
          if (!this.waitCount) this.isWaitCode = false
        }, 1000)
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapMutations([
      'vx_setData',
      'vx_toggleLogin'
    ]),
    init() {
      this.vx_toggleLogin(false)
    },
    resetError(item) {
      if (item) item.error = false
      else[this.formPhone, this.formPsw, this.formCode].forEach(d => (d.error = false))
    },
    toggleImgVerif(v = !this.isShowImgVerif) {
      if (v) {
        if (this.isWaitCode) return
        if (!this.checkForm({ from: 'send_code' })) return
      }
      this.isShowImgVerif = v
    },
    sendCode() {
      if (this.isWaitCode) return
      if (!this.checkForm({ from: 'send_code' })) return
      this.isWaitCode = true
      this.formCode.value = ''
      this.$api.sendCodeForPsw({
        mobile: this.formPhone.value,
        typeCode: this.activeAreaCode,
      }).then(res => {
        if (res.isOk) {
          this.$toast('发送成功')
        } else {
          this.isWaitCode = false
          this.$toast(res.msg || (res.message || {}).title || '发送失败')
        }
      }).catch(e => {
        console.error('获取验证码失败', e)
        this.$toast('网络连接失败')
        this.isWaitCode = false
      })
    },
    checkForm(config = {}) {
      this.resetError()
      let res = false // 是否有错
      let n = this.curStep
      if (n == 1) {
        let v = this.formPhone.value
        let item = this.areaCodeList.find(d => d.value == this.activeAreaCode)
        this.formPhone.error = !(item && v.length == item.len && item.reg.test(v))
        res = res || this.formPhone.error
        if (config.from !== 'send_code') {
          this.formCode.error = !this.formCode.value // 非空
          res = res || this.formCode.error
        }
      } else if (n == 2) {
        this.formPsw.error = !this.formPsw.value // 非空
        res = this.formPsw.error
      }
      // 没有错误则返回true
      return !res
    },
    doConfirm() {
      this.resetError()
      let n = this.curStep
      if (n == 1) {
        // return this.curStep++
        if (!this.checkForm()) return
        this.$api.verifyCodeForPsw({
          mobile: this.formPhone.value,
          validate_code: this.formCode.value,
          typeCode: this.activeAreaCode
        }).then(res => {
          if (res.isOk) {
            this.curStep++
          } else {
            this.$toast(res.msg || (res.message || {}).context || (res.message || {}).title || '验证失败')
          }
        })
      } else if (n == 2) {
        // return this.curStep++
        if (!this.checkForm()) return
        this.$api.resetPsw({
            mobile: this.formPhone.value,
            validate_code: this.formCode.value,
            password: this.formPsw.value,
            typeCode: this.activeAreaCode,
        }).then(res => {
          if (res.isOk) {
            this.curStep++
            // this.vx_setToken(res.data)
          } else {
            this.$toast(res.msg || (res.message || {}).title || '重置失败')
          }
        })
      } else {
        let url = this.$route.query.back_url
        if (url) location.href = url
        else {
          if (history.length > 1) this.$router.back()
          else this.$router.replace('/')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@colorAct: #4b85ff;
@colorInact: #d8d8d8;

.resetpsw-container {
  min-width: @gb_minWidth;
  background: #f7f7f7;
}

.my-body {
  margin-top: 10px;
  padding: 30px 0;
  background: #fff;
}

.my-steps {
  padding: 60px 0;
  text-align: center;
}

.my-step {
  position: relative;
  display: inline-block;
  font-size: 20px;
  color: @colorInact;
  &:nth-child(n + 2) {
    margin-left: 37px;
    &::before {
      content: '';
      float: left;
      position: relative;
      width: 250px;
      height: 2px;
      margin-top: 15px;
      margin-right: 38px;
      background: @colorInact;
    }
    &.my-active:before {
      background: @colorAct;
    }
  }
  &.my-active {
    color: @colorAct;
    .my-step-group {
      background: @colorAct;
    }
  }
}

.my-step-group {
  position: relative;
  float: left;
  width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border-radius: 50%;
  background: @colorInact;
}

.my-step-num {
  color: #fff;
}

.my-step-name {
  position: absolute;
  top: 60px;
  left: 50%;
  white-space: nowrap;
  transform: translateX(-50%);
}

.my-form {
  width: 326px;
  margin: 0 auto;
}

.my-form_3 {
  font-size: 20px;
  color: #333333;
  text-align: center;
  i {
    display: block;
    margin: 60px 0 20px;
    color: @colorAct;
    font-size: 50px;
    text-align: center;
  }
}

.my-inputgroup {
  position: relative;
  margin-top: 30px;
}

.my-inputgroup-witharea {
  select {
    float: left;
    width: 105px;
    height: 50px;
    line-height: 50px;
    margin-right: 15px;
    padding-left: 5px;
    border: 1px solid #d8d8d8;
    border-radius: 2px;
    color: #333;
    box-sizing: border-box;
    outline: none;
    &, option {
      font-size: 16px;
    }
  }
  .my-inputwrap {
    float: left;
    width: calc(100% - 120px);
    margin-top: 0;
  }
}

.my-inputgroup-withcode {
  .my-inputwrap {
    float: left;
    width: 60%;
    margin-top: 0;
    margin-right: 15px;
  }
  .my-inputbtn {
    float: left;
    width: calc(40% - 15px);
  }
}

.my-inputbtn {
  line-height: 46px;
  text-align: center;
  border: 1px solid #d8d8d8;
  border-radius: 2px;
  color: @colorAct;
  cursor: pointer;
  &.js-is-wait {
    color: #a6a6a6;
  }
}

.my-inputwrap {
  position: relative;
  height: 50px;
  margin-top: 30px;
  border: 1px solid #d8d8d8;
  border-radius: 2px;
  input {
    width: 100%;
    height: 100%;
    line-height: 28px;
    padding: 10px 10px 10px 40px;
    font-size: 16px;
    color: #333;
    border: none;
    outline: none;
    &::placeholder {
      color: #999;
    }
  }
}

.my-inputicon {
  position: absolute;
  left: 10px;
  top: 50%;
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  transform: translateY(-50%);
  pointer-events: none;
}

.my-inputicon_phone {
  background-image: url(~@/assets/inputicon_phone.png);
}

.my-inputicon_psw {
  background-image: url(~@/assets/inputicon_psw.png);
}

.my-inputicon_code {
  background-image: url(~@/assets/inputicon_code.png);
}

.my-inputtip {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 3px;
  line-height: 20px;
  font-size: 14px;
  color: #ff2626;
}

.my-forgetpsw {
  position: absolute;
  margin-top: 3px;
  width: 100%;
  height: 21px;
  line-height: 21px;
  font-size: 15px;
  color: @colorAct;
  text-align: right;
}

.my-loginbtn {
  margin-top: 30px;
  line-height: 50px;
  border-radius: 2px;
  font-size: 20px;
  color: #fff;
  background: @colorAct;
  text-align: center;
}
</style>
